export default __webpack_public_path__ + "static/media/image16.d864ab30.jpg";